import { Star } from "lucide-react";

/**
 * Interactive 1-4 star rating.
 * Clicking the same value again resets to 0.
 */
export default function StarScore({ value = 0, onChange, readOnly = false, size = "md", testId = "star-score" }) {
  const stars = [1, 2, 3, 4];
  const sizes = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  };
  const cls = sizes[size] || sizes.md;

  return (
    <div className="inline-flex items-center gap-0.5" data-testid={testId}>
      {stars.map((n) => {
        const active = n <= value;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            onClick={(e) => {
              e.stopPropagation();
              if (readOnly) return;
              onChange?.(value === n ? 0 : n);
            }}
            data-testid={`${testId}-${n}`}
            className={`rounded transition-transform ${
              readOnly ? "cursor-default" : "cursor-pointer hover:scale-110"
            }`}
            aria-label={`Score ${n}`}
          >
            <Star
              className={`${cls} ${
                active
                  ? "fill-amber-400 text-amber-400"
                  : "text-muted-foreground/40"
              }`}
              strokeWidth={1.5}
            />
          </button>
        );
      })}
    </div>
  );
}
